import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [
        RouterLink,
        MatIcon,
        MatButtonModule,
        MatIcon
    ],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent {
    constructor(
        private authService: MsalService,
    ) { }
    activeAccount = this.authService.instance.getActiveAccount()?.name;
}
